var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrollDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.15168 12.3515C5.62027 11.8828 6.38011 11.8828 6.84871 12.3515L12.0002 17.503L17.1517 12.3515C17.6203 11.8828 18.3801 11.8828 18.8487 12.3515C19.3174 12.8201 19.3174 13.5799 18.8487 14.0485L12.8487 20.0485C12.3801 20.5171 11.6203 20.5171 11.1517 20.0485L5.15168 14.0485C4.68307 13.5799 4.68307 12.8201 5.15168 12.3515Z",
    fill: "url(#paint0_linear_250_1046)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.15168 5.15152C5.62027 4.68289 6.38011 4.68289 6.84871 5.15152L12.0002 10.303L17.1517 5.15152C17.6203 4.68289 18.3801 4.68289 18.8487 5.15152C19.3174 5.62015 19.3174 6.37994 18.8487 6.84858L12.8487 12.8486C12.3801 13.3172 11.6203 13.3172 11.1517 12.8486L5.15168 6.84858C4.68307 6.37994 4.68307 5.62015 5.15168 5.15152Z",
    fill: "url(#paint1_linear_250_1046)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_250_1046",
    x1: 12.0002,
    y1: 12,
    x2: 12.0002,
    y2: 20.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD00AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7064E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_250_1046",
    x1: 12.0002,
    y1: 4.80005,
    x2: 12.0002,
    y2: 13.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD00AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7064E9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollDown);
export default __webpack_public_path__ + "static/media/scrollDown.d529fa6c412d894fcadb2849e3e7cef7.svg";
export { ForwardRef as ReactComponent };